import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { mixpanel, constants } from 'common/helpers'

import Title from 'components/_new/typography/deprecated/Title/Title'
import Button from 'components/_new/Button/Button'
import Picture from 'components/ui/Picture/Picture'
import { WidthContainer } from 'components/_new/layout/widthContainer'

// resolve picture x2
import image from './images/footer.png'


const BottomSection = ({ messages, redirectLink }) => (
  <Fragment>
    <WidthContainer>
      <Title message={messages.title} />
      <Button
        title={messages.buttonTitle}
        to={redirectLink}
        size="md"
        color="brand"
        rightIcon="rightArrowSmall"
        fullWidth
        onClick={() => {
          mixpanel.track(constants.analyticsEvents.newThankYouPage.goToCatalogClick, {
            placement: 'bottom',
          })
        }}
      />
    </WidthContainer>
    <Picture fullWidth {...image} />
  </Fragment>
)


BottomSection.propTypes = {
  redirectLink: PropTypes.string,
}


export default BottomSection
